<script setup lang="ts">
const telegramChannelUrl = 'https://t.me/belong_support'
</script>

<template>
  <NuxtLink
    :to="telegramChannelUrl"
    target="_blank"
    class="fixed bottom-5 right-5 w-12 h-12 bg-[#7440ee] rounded-full flex items-center justify-center z-999999"
    aria-label="Telegram Help Button"
  >
    <i class="i-ic:baseline-telegram w-8 h-8" />
  </NuxtLink>
</template>
